import React from "react";

export default function DataContainer({ children }) {
  return (
    <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">{children}</div>
  );
}
